<template>
	<v-treeview fill-height
        style="font-size:15px; background-color: #e5e7eb !important;"
        ref="contentTree"
        v-model="treeModel"
        
        :open.sync="treeOpenNodes"
        :active.sync="treeActiveItem"
		
        :items="treeItems"
        activatable
        item-key="id"
		item-text="editorMetaData.treeNodeLabel"
        hoverable
        dense
        class="treeCompactNodes red lighten-4 ma-0 pa-0 overflow-y-auto"
    >
        <template v-slot:prepend="{ item, open }">
			<div class="ai-highlight-top" style="visibility: hidden; width: 100%; height: 6px; background: #000000; position: absolute; left: 0px; top: -3px; pointer-events: none; opacity: 0;"/>
			<div class="ai-highlight-middle" style="visibility: hidden; width: 100%; height: 30px; background: #000000; position: absolute; left: 0px; top: 3px; pointer-events: none; opacity: 0;"/>
			<div class="ai-highlight-bottom" style="visibility: hidden; width: 100%; height: 6px; background: #000000; position: absolute; left: 0px; top: 33px; pointer-events: none; opacity: 0;"/>
            <v-icon v-if="item.nodeType === 'sorting-folder'" color="#7a4646" style="font-size: 22px">
                {{ open ? "mdi-folder-open" : "mdi-folder" }}
            </v-icon>
            <v-icon color="#3e578a" v-else>{{ item.treeIcon }}</v-icon>
			<div class="ai-id" :treeName="treeName" :id="item.id" :isfolder="item.folder === true"/>
        </template>
    </v-treeview>
</template>


<script>

// ----------------------------------------------------
//  Main script
// ----------------------------------------------------

import fb from '@/shift/fb';
import agile from '@/shift/agile';
//import agileFb from "@/shift/agileFb";
import { AiEventBus } from '@/main';
import { TweenMax } from "gsap/all";



export default
{
	name: 'SharedContentEditorTree',
	
	props:
	{
		/* openFolderEdit:
		{
			type: Function
		},

		openPageTypeEdit:
		{
			type: Function
		}, */

	},
	

	data: () =>
    ({
		treeName: 'sharedContentTree',
		nodeTypes: {
			page: "mdi-page-next-outline",
		},

		treeOpenNodes: [],
		treeActiveItem: [],
		treeModel: [],

		treeItems: [],
		treeOrphans: [],
		
		windowSize:
		{
			x: 0,
			y: 0
		},

		navigation:
		{
			shown: false,
			width: 200,
			borderSize: 3
		},

		trackedTreeNodes: [],

		isDragging: '',
		isDraggingOffsetY: 0,

		hasInitializedUserSync: false,
		allowUserSync: true,
		boundOnResize: null,

		preventTreeActiveItemLoop: false,
	}),

    computed:
	{
		routeKey()
		{
			return this.$route.params.key;
		},

		appBarHeight()
		{
			return agile.appBarHeight();
		},

		toolBarPrimaryHeight()
		{
			return agile.toolBarPrimaryHeight();
		},

		toolBarSecondaryHeight()
		{
			return agile.toolBarSecondaryHeight();
		},
	},
	
	watch:
	{
		treeItems()
		{
			//console.log("tree change");

		},
		
		treeModel()
		{
			//console.log("tree change");

		},

		treeActiveItem()
		{	
			if (!this.preventTreeActiveItemLoop)
			{
				const showId = (this.treeActiveItem[0]) ? this.treeActiveItem[0] : '' ;
				this.$parent.$parent.activeTreeNodeId = (showId) ? 'Id: '+showId : '';
				
				// Make sure the other content tree is unselected when we select in this
				this.$parent.$parent.$refs.treeComponent.resetTreeActiveItem();
				

				if (showId)
				{
					this.$parent.$parent.activeTreeNodeType = agile.getObjectById(this.treeItems, showId).editorMetaData.templateName;
				}
				else
				{
					this.$parent.$parent.activeTreeNodeType = '';
				}
			}
		},

		treeOpenNodes()
		{
			// We want to save the folders open/closed state for you the user
			if (agile.loggedInUser.uid && this.hasInitializedUserSync && this.allowUserSync)
			{
				
				// We don't want to spam the firestore database, wait atleast 1 second before we update, and block other requests to sync
				this.allowUserSync = false;
				

				setTimeout(() =>
				{
					this.allowUserSync = true;

					if (this.treeOpenNodes !== undefined)
					{
						const saveStateData =
						{
							sharedContentEditorTreeState: this.treeOpenNodes,
						}
						
						// Ok, do the sync command
						fb.db.collection("users").doc(agile.loggedInUser.uid).collection("saved-states").doc(this.routeKey).set(saveStateData, { merge: true })
						.then(() =>
						{
							//console.log("Updated tree open state", this.treeOpenNodes);
						})
						.catch((error) =>
						{
							console.log('Error syncronizing user tree state:', error.message);
						});
					}

				}, 1000);

				
			}

			// Every time we open a folder node, we need to update the nested children with listeners for drag and drop
			// Also when closing, we need to dispose of now unused nodes. Wait one millisecond to wait for Vuetify to update
			setTimeout(this.updateTreeDrag, 1);
		},
		
	},

	created()
	{
		this.boundOnResize = this.onResize.bind(this)
		window.addEventListener('resize', this.boundOnResize);
	},

	mounted()
	{
		this.onResize();
	},

    methods:
    {

		resetTreeActiveItem()
		{
			this.preventTreeActiveItemLoop = true;
			this.treeActiveItem = [];
			setTimeout(() =>
			{
				this.preventTreeActiveItemLoop = false;
			}, 500);
		},


		// --------------------------------------------------------------------
		//
		//	Update the tree's drag and drop capabilities. Vuetify v-tree-view
		//	does not support drag and drop. We fix this by manually detecting and 
		//	injecting the DOM of the tree, and then use native JS drag and drop.
		//	We then post changes to the Firestore and then update the tree based
		//	on live updates from Firebase and feed into the dataprovider of the tree.
		//
		// --------------------------------------------------------------------

		updateTreeDrag()
		{
			const visibleTreeNodes = this.$refs.contentTree.$el.getElementsByClassName('v-treeview-node__root');

			for (let i = 0; i < visibleTreeNodes.length; i++)
			{
				// Check if we have registred this node before
				let found = false;

				for (let j = 0; j < this.trackedTreeNodes.length; j++)
				{
					if (visibleTreeNodes[i] === this.trackedTreeNodes[j])
					{
						found = true;
						break;
					}
				}

				if (!found)
				{
					// If this is a new node, then we register it and add listener
					this.trackedTreeNodes.push(visibleTreeNodes[i]);
					

					// Turn off pointer events for the content child nodes (icon, label, etc.) in the node, because it
					// creates a mess with the dragenter/leave events.
					const nodeContent = visibleTreeNodes[i].getElementsByClassName('v-treeview-node__content')[0];
					nodeContent.style.pointerEvents = 'none';

					this.addDragAndDropListeners(visibleTreeNodes[i]);

					//console.log('New node', visibleTreeNodes[i]);
				}
			}

			// Find orphaned nodes (typical nodes in folders that are closed, or deleted)
			for (let i = this.trackedTreeNodes.length-1; i >= 0; i--)
			{
				let foundInTree = false;

				for (let j = 0; j < visibleTreeNodes.length; j++)
				{
					if (visibleTreeNodes[j] === this.trackedTreeNodes[i])
					{
						foundInTree = true;
						break;
					}
				}

				// If the node is found in tree, then it is alive and kicking. If not
				// found, it is an orphan and needs to be removed.
				if (!foundInTree)
				{
					// Orphan node found, remove listeners and remove it from array
					this.removeDragAndDropListeners(this.trackedTreeNodes[i]);
					this.trackedTreeNodes.splice(i, 1);
				}
			}

        },
		

		// --------------------------------------------------------------------
		//
		//	Add and remove drag and drop listeners (and double click)
		//
		// --------------------------------------------------------------------

		addDragAndDropListeners(target)
		{
			if (target.dragListenersAdded) return;
			target.dragListenersAdded = true;

			//  Listen to double click
			target.addEventListener('dblclick', this.onDoubleClick);

			//  Listen to press so we start drag
			target.addEventListener('mousedown', this.startDrag);

			//  Listen to when the actual drag starts
			target.addEventListener('dragstart', this.startedDrag);
			
			//  Listen to drop
			target.addEventListener('drop', this.onDrop, false);

			//  Prevent some default js behaviour
			['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
				target.addEventListener(eventName, agile.preventDefaults, false);
			});

			//  Add highlighting when dragging item over
			['dragenter', 'dragover'].forEach(eventName =>
			{
				target.addEventListener(eventName, this.addDropTargetHighlights, false);
			});

			// Remove highlighting when dragging item over
			['dragleave', 'drop'].forEach(eventName =>
			{
				target.addEventListener(eventName, this.removeDropTargetHighlights, false);
			});
		},

		removeDragAndDropListeners(target)
		{
			if (!target.dragListenersAdded) return;
			target.dragListenersAdded = false;

			target.removeEventListener('dblclick', this.onDoubleClick);
			target.removeEventListener('mousedown', this.startDrag);
			target.removeEventListener('dragstart', this.startedDrag);
			target.removeEventListener('drop', this.onDrop, false);

			['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
				target.removeEventListener(eventName, agile.preventDefaults, false);
			});

			['dragenter', 'dragover'].forEach(eventName =>
			{
				target.removeEventListener(eventName, this.addDropTargetHighlights, false);
			});

			['dragleave', 'drop'].forEach(eventName =>
			{
				target.removeEventListener(eventName, this.removeDropTargetHighlights, false);
			});
		},


		// --------------------------------------------------------------------
		//
		//	Drag and drop listeners (and double click)
		//
		// --------------------------------------------------------------------
		
		onDoubleClick(e)
		{	
			const el = e.currentTarget.getElementsByClassName('ai-id')[0];
			const id = el.id;
			
			const openingItem = agile.getObjectById(this.treeItems, id);

			if (openingItem.nodeType === 'shared-content')
			{
				AiEventBus.$emit('contentEditorOpenDocument', id);
			}
			else if (openingItem.nodeType === 'sorting-folder')
			{
				AiEventBus.$emit('contentEditorOpenFolder', id);
			}
		},


		startDrag(e)
		{
			e.currentTarget.draggable = true;
			
			const id = e.currentTarget.getElementsByClassName('ai-id')[0].id;
			
			this.isDragging = id;
			this.isDraggingOffsetY = e.offsetY; // Remember the offset, so we can position the drop more precicely
		},

		startedDrag(e)
		{
			const id = e.currentTarget.getElementsByClassName('ai-id')[0].id;
			const dataString = `{ "id": "${id}", "treeName": "${this.treeName}" }`;
			e.dataTransfer.setData('text/plain', dataString);
		},

		onDrop(e)
		{

			// Get id of drop target
			let incoming = null; try { incoming = JSON.parse(e.dataTransfer.getData('text')); } catch (er) { /**/ }
			e.dataTransfer.clearData();
			if (!incoming) return; // We don't know whats dropping here.. go away now!
			const localDrop = (incoming.treeName === this.treeName);
			if (!localDrop) return; // Accept no outside tree elements here

			const el = e.currentTarget.getElementsByClassName('ai-id')[0];
			const id = el.id;
			if (incoming.id === id) return; // For some reason the drag and the drop are the same
			
			const isFolder = el.getAttribute('isfolder') === 'true';
			const incomingItem = agile.getObjectById( (localDrop) ? this.treeItems : this.$parent.$parent.$refs.sharedTreeComponent.treeItems , incoming.id);
			const dropZone = agile.getObjectById(this.treeItems, id);
			let dropZoneSharedRootId = (dropZone.sharedRootId == 'sharedRoot') ? dropZone.id : dropZone.sharedRootId; dropZoneSharedRootId;
			if (incomingItem.nodeType === 'shared-content' && incomingItem.sharedRootId !== 'sharedRoot' && (incomingItem.sharedRootId !== dropZoneSharedRootId)) return; // Don't 


			// Getting strange values with offsetY ~^
			const useY = e.pageY-e.currentTarget.getBoundingClientRect().top-this.isDraggingOffsetY;

			if (useY < -12) // Move above
			{
				this.rearrangeNode(this.isDragging, id, true);
			}
			else if (useY > 12) // Move below
			{
				this.rearrangeNode(this.isDragging, id, false);
			}
			else // Nest inside
			{
				if (isFolder) this.relocateNode(this.isDragging, id);
			}

		},
		
		addDropTargetHighlights(e)
		{
			const el = e.currentTarget.getElementsByClassName('ai-id')[0];
			const id = el.id;
			const isFolder = el.getAttribute('isfolder') === 'true';
			
			if (this.isDragging === id) return;
			
			const top = e.currentTarget.getElementsByClassName('ai-highlight-top')[0];
			const middle = e.currentTarget.getElementsByClassName('ai-highlight-middle')[0];
			const bottom = e.currentTarget.getElementsByClassName('ai-highlight-bottom')[0];

			// Getting strange values with offsetY ~^
			const useY = e.pageY-e.currentTarget.getBoundingClientRect().top-this.isDraggingOffsetY;

			if (useY < -12) // Move above
			{
				TweenMax.to(top, 0.5, { autoAlpha:0.2, overwrite:true });
				TweenMax.to(middle, 0.3, { autoAlpha:0, overwrite:true });
				TweenMax.to(bottom, 0.3, { autoAlpha:0, overwrite:true });
			}
			else if (useY > 12) // Move below
			{
				TweenMax.to(top, 0.3, { autoAlpha:0, overwrite:true });
				TweenMax.to(middle, 0.3, { autoAlpha:0, overwrite:true });
				TweenMax.to(bottom, 0.5, { autoAlpha:0.2, overwrite:true });
			}
			else // Nest inside
			{
				TweenMax.to(top, 0.3, { autoAlpha:0, overwrite:true });
				if (isFolder) TweenMax.to(middle, 0.5, { autoAlpha:0.2, overwrite:true });
				TweenMax.to(bottom, 0.3, { autoAlpha:0, overwrite:true });
			}

		},


		removeDropTargetHighlights(e)
		{
			const top = e.currentTarget.getElementsByClassName('ai-highlight-top')[0];
			const middle = e.currentTarget.getElementsByClassName('ai-highlight-middle')[0];
			const bottom = e.currentTarget.getElementsByClassName('ai-highlight-bottom')[0];

			TweenMax.to(top, 0.3, { autoAlpha:0, overwrite:true });
			TweenMax.to(middle, 0.3, { autoAlpha:0, overwrite:true });
			TweenMax.to(bottom, 0.3, { autoAlpha:0, overwrite:true });

		},





		// --------------------------------------------------------------------
		//
		//	Drag and drop operation, here we nest a node in a folder
		//
		// --------------------------------------------------------------------


		relocateNode(idToMove, moveToId)
		{
			if (idToMove === moveToId) return; // Can't drop on yourself :o
			
			const objectToDrop = agile.getObjectById(this.treeItems, idToMove);
			const dropToObject = agile.getObjectById(this.treeItems, moveToId);

			// If folder we are dropping to already have children, use the 'rearrangeNode' function			
			if (dropToObject.children.length > 0)
			{
				this.rearrangeNode(idToMove, dropToObject.children[dropToObject.children.length-1].id, false, true)
				return;
			}

			// If folder is empty, continue here
			if (objectToDrop.nodeType === 'sorting-folder' && dropToObject.nodeType === 'shared-content')
			{
				this.$root.$alert('Wrong move', 'Can not nest sorting folders inside shared content.');
				return;
			}

			if (dropToObject && dropToObject.parentItem)
			{
				// Check if use is not dragging the folder to it's own subfolder
				let isAncestor = false;
				let pi = dropToObject.parentItem;
				while (pi !== 'root' || !pi)
				{
					if (pi.id === idToMove)
					{
						isAncestor = true;
						break;
					}
					pi = pi.parentItem;
				}
				
				if (isAncestor) return; // Don't want to put node into its own node
				
				// Open the folder we are moving into
				
				if (!this.treeOpenNodes.includes(moveToId)) this.treeOpenNodes.push(moveToId);

				const updateData =
				{
					editorMetaData:
					{
						treeNodePosition: dropToObject.children.length,
						treeNodeParent: moveToId
					}
				};
				//(objectToDrop.nodeType === 'folder')
				const dbTable = (objectToDrop.nodeType === 'sorting-folder') ? 'shared-content-sorting-folders' : 'shared-content';

				const collection = fb.db
					.collection('content-collection')
					.doc('content-doc')
					.collection(this.routeKey)
					.doc(this.routeKey)
					.collection(dbTable);//.collection('shared-content');

			
				collection.doc(idToMove).set(updateData, { merge: true })
				.then(() =>
				{






					//objectToDrop
					//dropToObject



					// -------------------------------------------------
					//	Now we need to sync the shared content
					//	that is spread around the normal content tree
					// -------------------------------------------------

					if (dropToObject.nodeType === 'shared-content')
					{
						const contentCollection = fb.db
							.collection('content-collection')
							.doc('content-doc')
							.collection(this.routeKey)
							.doc(this.routeKey)
							.collection('content');

						return (async () =>
						{
							const promises = [];

							// Get the dragging instances
							promises.push(
								contentCollection.where('originalId', '==', objectToDrop.id).where('trash', '==', false).get()
								.then((querySnapshot) =>
								{
									const returnArray = [];
									querySnapshot.forEach(function(doc)
									{
										const docData = doc.data();
										returnArray.push(
										{
											position: 0,
											contentTreeId: doc.id,
											contentTreeParent: docData.editorMetaData.treeNodeParent,
											sharedRootId: docData.sharedRootId,
											originalId: objectToDrop.id,
											type: 'droppingChild'
										} );
									});
									return returnArray;
								})
								.catch((error) =>
								{
									console.log("Error syncing shared content folder drop", error.message);
									return 'error';
								})
							);
							

							// Then we get the parents
							promises.push(
								contentCollection.where('originalId', '==', dropToObject.id).where('trash', '==', false).get()
								.then((querySnapshot) =>
								{
									const returnArray = [];
									querySnapshot.forEach(function(doc)
									{
										const docData = doc.data();
										returnArray.push( { contentTreeId: doc.id, originalId: dropToObject.id, type: 'parent', sharedRootId: docData.sharedRootId } );
									});
									return returnArray;
								})
								.catch((error) =>
								{
									console.log("Error syncing shared content", error.message);
									return 'error';
								})
							);
							

							let syncDocsResult = await Promise.all(promises);
							const sharedGroupsToSync = [];
							const docsToSync = [];

							// Lets split them up in parents and childs for convenience down the road
							for (let i = 0; i < syncDocsResult.length; i++)
							{
								for (let j = 0; j < syncDocsResult[i].length; j++)
								{
									if (syncDocsResult[i][j].type === 'parent')
									{
										// If we have the the very shared content root as parent, the 'sharedRootId' will return 'sharedRoot' as
										// value. We want its own ID as value to more uniformly compare the shared content enclaves.
										if (syncDocsResult[i][j].sharedRootId === 'sharedRoot') syncDocsResult[i][j].sharedRootId = syncDocsResult[i][j].contentTreeId;
										sharedGroupsToSync.push( { parent: syncDocsResult[i][j], children:[] } );
									}
									else if (syncDocsResult[i][j].type === 'droppingChild')
									{
										docsToSync.push(syncDocsResult[i][j]);
									}
									
								}
							}

							// Lets group them in. This is getting heavy with loops, but what the hell, we need to do it right
							// #Todo: Can probably be refactored to perform much better, this whole schebang here is crazy
							
							for (let i = 0; i < sharedGroupsToSync.length; i++)
							{
								for (let j = 0; j < docsToSync.length; j++)
								{
									if (docsToSync[j].sharedRootId === sharedGroupsToSync[i].parent.sharedRootId) sharedGroupsToSync[i].children.push(docsToSync[j]);
								}
							}

							// ----------------------------------------------------------
							//	Now we got the documents, organize and update them now
							// ----------------------------------------------------------

							const syncBatch = fb.db.batch();

							for (let i = 0; i < sharedGroupsToSync.length; i++)
							{
								for (var j = 0; j < sharedGroupsToSync[i].children.length; j++)
								{
									const syncSrc = sharedGroupsToSync[i].children[j];

									syncBatch.set(contentCollection.doc(syncSrc.contentTreeId),
									{
										editorMetaData:
										{
											treeNodePosition: syncSrc.position,
											treeNodeParent: sharedGroupsToSync[i].parent.contentTreeId,
										}
									}, { merge: true });	
								}
							}

							// OK, go ahead and sync! Phew...
							syncBatch.commit()
							.then(() =>
							{
								//console.log("Operation sync stuff completed!");
							})
							.catch((error) =>
							{
								this.$root.$alert("Error batch syncing shared content", error.message);
							});
							
						})();
					}













				})
				.catch((error) =>
				{
					console.log('Error moving node into node in shared content tree:', error.message);
				});



				//this.updateItemToFirestore(dbTable, updateData, idToMove);
					
				
				
			}
			
		},
















		// --------------------------------------------------------------------
		//
		//	Drag and drop operation, we place a node above or below some other node
		//
		// --------------------------------------------------------------------

		rearrangeNode(idToMove, _moveToId, _above, dropDirectlyOnFolder = false) // if 'above' is false, then it is re-ordered below
		{
			let above = _above;
			let moveToId = _moveToId;
			if (idToMove === moveToId) return; // Makes no sense to move above or below yourself...
			
			// ----------------------------------
			//	Get new order sorted
			// ----------------------------------

			const objectDropping = agile.getObjectById(this.treeItems, idToMove);
			let moveToParent = agile.getObjectParentByChildId(this.treeItems, moveToId);

			//console.log(":::", moveToParent.nodeType, objectDropping.nodeType);

			if (moveToParent !== null && objectDropping.nodeType === 'sorting-folder' && moveToParent.nodeType === 'shared-content')
			{
				this.$root.$alert('Wrong move', 'Can not nest sorting folders inside shared content.');
				return;
			}
			
			let moveToArray = agile.getObjectParentArrayById(this.treeItems, moveToId);

			// If we are dropping "below" a folder node that is open, then we actually want to place
			// the node inside it, and at index 0.
			if (!above && !dropDirectlyOnFolder)
			{
				for (let i = 0; i < this.treeOpenNodes.length; i++)
				{
					if (this.treeOpenNodes[i] === moveToId)
					{
						const moveToObject = agile.getObjectById(this.treeItems, moveToId);
						if (moveToObject.children && moveToObject.children.length > 0)
						{
							// Ok, so, when we try to move "below" an open folder, we change the placement
							// to be the "above" the first node in the folder!
							moveToArray = moveToObject.children;
							moveToId = moveToObject.children[0].id;
							above = true;

							//console.log("convert to child");
							
							moveToParent = moveToObject;//agile.getObjectParentByChildId(this.treeItems, moveToId);

							// BUT HOLD IT!
							// Is it a sorting folder you are trying to move in here again? nono..
							// Can't nest sorting folders in shared content folders, so check again (already checked in the beginning, but parent might have changed on the way)
							
							if (moveToParent !== null && objectDropping.nodeType === 'sorting-folder' && moveToParent.nodeType === 'shared-content')
							{
								this.$root.$alert('Wrong move', 'Can not nest sorting folders inside shared content.');
								return;
							}
							
						}
						break;
					}
				}
				
			}
			
			

			// Check if user is not dragging the folder to it selft as subfolder
			let isAncestor = false;
			let pi = moveToArray[0].parentItem;
			while (pi !== 'root' || !pi)
			{
				if (pi.id === idToMove)
				{
					isAncestor = true;
					break;
				}
				pi = pi.parentItem;
			}
			
			if (isAncestor)
			{
				//this.$root.$alert('Wrong move', 'Can not nest inside its own folder');
				return; // Yea, dont put yourself into yourself... abort operation
			}


			// Also be aware, we might not only be arranging sort order of node
			// but may be dragging into a completely different parent node as well
			
			const newOrder = [];

			for (let i = 0; i < moveToArray.length; i++)
			{
				if (moveToArray[i].id === moveToId)
				{
					if (above) newOrder.push( { id: idToMove, nodeType: objectDropping.nodeType } );
					newOrder.push( { id: moveToArray[i].id, nodeType: moveToArray[i].nodeType } );
					if (!above) newOrder.push( { id: idToMove, nodeType: objectDropping.nodeType } );
				}
				// If the id of item we are moving are already in same array (which
				// is very likely), we do not append that twice (we already did above)
				else if (moveToArray[i].id !== idToMove)
				{
					newOrder.push( { id: moveToArray[i].id, nodeType: moveToArray[i].nodeType } );
				}
			}

			//const movedNodePosition = newOrder.map(function(e) { return e.id; }).indexOf(idToMove);
			

			// ----------------------------------
			//	Get started with firebase op
			// ----------------------------------

			const sharedCollection = fb.db
				.collection('content-collection')
				.doc('content-doc')
				.collection(this.routeKey)
				.doc(this.routeKey)
				.collection('shared-content');

			const sortingCollection = fb.db
				.collection('content-collection')
				.doc('content-doc')
				.collection(this.routeKey)
				.doc(this.routeKey)
				.collection('shared-content-sorting-folders');


			//Todo: Batch commands only supports max 500 batch jobs. Bigger structures will fail, so we need to queue them.
			const batch = fb.db.batch();
			
			for (let i = 0; i < newOrder.length; i++)
			{
				const useCol = (newOrder[i].nodeType === 'sorting-folder') ? sortingCollection : sharedCollection ;
				batch.set(useCol.doc(newOrder[i].id),
				{
					editorMetaData:
					{
						treeNodePosition: i,
						treeNodeParent: (moveToParent === null) ? 'root' : moveToParent.id ,
					}
				}, { merge: true });
			}

			// ----------------------------------
			//	Do the update
			// ----------------------------------
			
			batch.commit()
			.then(() =>
			{
				// -------------------------------------------------
				//	Now we need to sync the shared content
				//	that is spread around the normal content tree
				// -------------------------------------------------
				
				if (moveToParent && moveToParent.nodeType === 'shared-content')
				{
					const contentCollection = fb.db
						.collection('content-collection')
						.doc('content-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('content');

					return (async () =>
					{
						const promises = [];

						// -------------------------------------------------
						//	Get the shared documents in the content database
						//	so we can sync them
						// -------------------------------------------------

						// First we get the siblings to reorganize
						for (let i = 0; i < newOrder.length; i++)
						{
							promises.push(
								contentCollection.where('originalId', '==', newOrder[i].id).where('trash', '==', false).get()
								.then((querySnapshot) =>
								{
									const returnArray = [];
									querySnapshot.forEach(function(doc)
									{
										const docData = doc.data();
										returnArray.push(
										{
											position: i,
											contentTreeId: doc.id,
											contentTreeParent: docData.editorMetaData.treeNodeParent,
											sharedRootId: docData.sharedRootId,
											originalId: newOrder[i].id,
											type: 'sibling'
										} );
									});
									return returnArray;
								})
								.catch((error) =>
								{
									console.log("Error syncing shared content", error.message);
									return 'error';
								})
							);
						}

						// Then we get the parents
						promises.push(
							contentCollection.where('originalId', '==', moveToParent.id).where('trash', '==', false).get()
							.then((querySnapshot) =>
							{
								const returnArray = [];
								querySnapshot.forEach(function(doc)
								{
									const docData = doc.data();
									returnArray.push( { contentTreeId: doc.id, originalId: moveToParent.id, type: 'parent', sharedRootId: docData.sharedRootId } );
								});
								return returnArray;
							})
							.catch((error) =>
							{
								console.log("Error syncing shared content", error.message);
								return 'error';
							})
						);
						

						let syncDocsResult = await Promise.all(promises);
						const sharedGroupsToSync = [];
						const docsToSync = [];

						// Lets split them up in parents and childs for convenience down the road
						for (let i = 0; i < syncDocsResult.length; i++)
						{
							for (let j = 0; j < syncDocsResult[i].length; j++)
							{
								if (syncDocsResult[i][j].type === 'parent')
								{
									// If we have the the very shared content root as parent, the 'sharedRootId' will return 'sharedRoot' as
									// value. We want its own ID as value to more uniformly compare the shared content enclaves.
									if (syncDocsResult[i][j].sharedRootId === 'sharedRoot') syncDocsResult[i][j].sharedRootId = syncDocsResult[i][j].contentTreeId;
									sharedGroupsToSync.push( { parent: syncDocsResult[i][j], children:[] } );
								}
								else if (syncDocsResult[i][j].type === 'sibling')
								{
									docsToSync.push(syncDocsResult[i][j]);
								}
								
							}
						}

						// Lets group them in. This is getting heavy with loops, but what the hell, we need to do it right
						// #Todo: Can probably be refactored to perform much better, this whole schebang here is crazy
						
						for (let i = 0; i < sharedGroupsToSync.length; i++)
						{
							for (let j = 0; j < docsToSync.length; j++)
							{
								if (docsToSync[j].sharedRootId === sharedGroupsToSync[i].parent.sharedRootId) sharedGroupsToSync[i].children.push(docsToSync[j]);
							}
						}

						// ----------------------------------------------------------
						//	Now we got the documents, organize and update them now
						// ----------------------------------------------------------

						const syncBatch = fb.db.batch();

						for (let i = 0; i < sharedGroupsToSync.length; i++)
						{
							for (var j = 0; j < sharedGroupsToSync[i].children.length; j++)
							{
								const syncSrc = sharedGroupsToSync[i].children[j];

								syncBatch.set(contentCollection.doc(syncSrc.contentTreeId),
								{
									editorMetaData:
									{
										treeNodePosition: syncSrc.position,
										treeNodeParent: sharedGroupsToSync[i].parent.contentTreeId,
									}
								}, { merge: true });	
							}
						}

						// OK, go ahead and sync! Phew...
						syncBatch.commit()
						.then(() =>
						{
							//console.log("Operation sync stuff completed!");
						})
						.catch((error) =>
						{
							this.$root.$alert("Error batch syncing shared content", error.message);
						});
						
					})();
					
				}


			})
			.catch((error) =>
			{
				this.$root.$alert("Error batch updating sorting or shared folders", error.message);
			});
			

		},















		// ----------------------------------
		//	Update command for firestore
		// ----------------------------------

		updateItemToFirestore(dbTable, thingsToUpdate, id)
		{
			// Setup command
			const collection = fb.db
				.collection('content-collection')
				.doc('content-doc')
				.collection(this.routeKey)
				.doc(this.routeKey)
				.collection(dbTable);//.collection('shared-content');

			
			collection.doc(id).update(thingsToUpdate)
			.then(() =>
			{
				//console.log("Updated");
			})
			.catch((error) =>
			{
				console.log('Error updating:', error.message);
			});
		},






		onResize()
		{
			/* const treeView = this.$refs.contentTree.$el;

			const computedfillHeight =
				window.innerHeight-
				this.appBarHeight-
				(this.toolBarPrimaryHeight*2)-
				this.toolBarSecondaryHeight;
			
			treeView.style.height = (computedfillHeight/2) + "px"; */
		},






		// --------------------------------------------------------------------
		//
		//	Build dataprovider for treeview, with nodes supplied live from Firestore!
		//
		// --------------------------------------------------------------------

		insertInTree(item)
		{
			if (!item.editorMetaData.treeNodeParent) item.editorMetaData.treeNodeParent = 'root'; // if item has no parent, make root it's parent
			
			if (item.editorMetaData.treeNodeParent === 'root')
			{
				item.parentItem = 'root';
				this.treeItems.push(item);
			}
			else
			{				
				const parent = agile.getObjectById(this.treeItems, item.editorMetaData.treeNodeParent);
				
				// We have no idea in which order we are receiving the tree items, so parent nodes might not
				// be built yet.
				if (parent)
				{
					
					// If we find the parent, store the item there
					if (!parent.children) // Parent doesnt accept children, put the node to root instead as safety solution
					{
						item.parentItem = 'root';
						this.treeItems.push(item);
					}
					else
					{
						
						item.parentItem = parent;
						parent.children.push(item);
					}
					
				}
				else
				{
					// If not, store it in orphans, and we will see if we find parent later
					this.treeOrphans.push(item);
				}
				
			}


			// Now check the orphans. Maybe our new item is parent to some orphaned item
			for (let i = this.treeOrphans.length-1; i >= 0; i--)
			{
				if (this.treeOrphans[i].editorMetaData.treeNodeParent === item.id)
				{
					if (!item.children)
					{
						console.log(`* Tree builder is trying to add treenode to parent that has no "children" object. Adding to root instead (${this.treeOrphans[i].editorMetaData.treeNodeLabel}).`);
						this.treeOrphans[i].parentItem = 'root';
						this.treeItems.push(this.treeOrphans[i]);
					}
					else
					{
						this.treeOrphans[i].parentItem = item;
						item.children.push(this.treeOrphans[i]);
					}

					// Ok, we have sorted that this is not an orphan anymore, take it out of orphan list
					this.treeOrphans.splice(i, 1);
				}
			}


			// Now we really check on behalf of the orphans. Do they have parents or not?

			let lastCount = 0;
			let currentCount = this.treeOrphans.length;

			while (lastCount !== currentCount) // Check until there are no possible parents for orphans
			{
				for (let i = this.treeOrphans.length-1; i >= 0; i--)
				{
					const checkItem = this.treeOrphans[i];
					const checkItemParent = agile.getObjectById(this.treeItems, checkItem.editorMetaData.treeNodeParent);
					
					

					if (checkItemParent)
					{
						// If we find the parent, store the item there
						if (!checkItemParent.children) // Parent doesnt accept children, put the node to root instead as safety solution
						{
							checkItem.parentItem = 'root';
							this.treeItems.push(checkItem);
						}
						else
						{		
							checkItem.parentItem = checkItemParent;
							checkItemParent.children.push(checkItem);
						}
						this.treeOrphans.splice(i, 1);
					}
				}

				//console.log(lastCount, currentCount);

				lastCount = currentCount;
				currentCount = this.treeOrphans.length;
			}


			// Update sort order
			// It seems a bit excessive to update the whole tree just because we added one or a few items? But maybe it is not so hard to process, who knows...
			agile.updateTreeSortOrder(this.treeItems, this.treeOpenNodes);
			
			// Update tree
			// We need to tick one before we go go
			setTimeout(this.updateTreeDrag, 1);
		},




		// --------------------------------------------------------------------
		//
		//	Update treeview dataprovider, after we get live data from firestore
		//
		// --------------------------------------------------------------------

		updateTreeItem(dataItem)
		{
			let updateItem = agile.getObjectById(this.treeItems, dataItem.id);


			if (!updateItem)
			{
				console.log("Update item is not good! (updateTreeItem)", updateItem)
			}
			else
			{
				// Lets update data
				updateItem.editorMetaData.treeNodeLabel = dataItem.editorMetaData.treeNodeLabel;
				updateItem.editorMetaData.treeNodePosition = dataItem.editorMetaData.treeNodePosition;
				
				if (updateItem.editorMetaData.treeNodeParent != dataItem.editorMetaData.treeNodeParent)
				{
					updateItem.editorMetaData.treeNodeParent = dataItem.editorMetaData.treeNodeParent;

					// Parent is changed, we need to remove item from tree
					updateItem = agile.getAndRemoveObjectById(this.treeItems, dataItem.id);

					const scopeThis = this;
					const tempActives = this.treeOpenNodes.slice();

					setTimeout(function()
					{
						if (!updateItem.editorMetaData.treeNodeParent) updateItem.editorMetaData.treeNodeParent = 'root';

						// Replace item
						if (updateItem.editorMetaData.treeNodeParent === 'root')
						{
							updateItem.parentItem = 'root';
							scopeThis.treeItems.push(updateItem);
						}
						else
						{
							const parent = agile.getObjectById(scopeThis.treeItems, updateItem.editorMetaData.treeNodeParent);
							updateItem.parentItem = parent;
							parent.children.push(updateItem);
						}

						// Update sort order
						agile.updateTreeSortOrder(scopeThis.treeItems, tempActives);
						scopeThis.treeOpenNodes = tempActives;
						
						// Update tree
						// We need to tick one before we go go
						setTimeout(scopeThis.updateTreeDrag, 1);

					}, 1);
					
				}
				else
				{
					// Update sort order
					agile.updateTreeSortOrder(this.treeItems, this.treeOpenNodes);

					// Update tree
					// We need to tick one before we go go
					setTimeout(this.updateTreeDrag, 1);
				}

			}
			
		},
        
	},


	


	// --------------------------------------------------------------------
	//
	//	VUE: Destroy event hook
	//
	// --------------------------------------------------------------------
	
	beforeDestroy()
	{
		window.removeEventListener('resize', this.boundOnResize);

		// Remove all custom drag and drop listeners in tree view
		for (let i = this.trackedTreeNodes.length-1; i >= 0; i--)
		{
			this.removeDragAndDropListeners(this.trackedTreeNodes[i]);
		}
	},


}

</script>